import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { LlmCostGroup } from '@/lib/types/dashboard/llmCost';
import { formatDateTime, formatPercent, formatTab, formatUsd, successRate } from './format';

/** account 別 / tab 別 共通のテーブル */
function GroupTable({ rows, withTab }: { rows: LlmCostGroup[]; withTab: boolean }) {
  const colSpan = withTab ? 6 : 5;
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>アカウント</TableCell>
            {withTab && <TableCell>タブ</TableCell>}
            <TableCell align="right">コスト</TableCell>
            <TableCell align="right">実行回数</TableCell>
            <TableCell align="right">成功率</TableCell>
            <TableCell>最終実行</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((g) => (
            <TableRow key={`${g.accountCode}/${g.tabId ?? ''}`}>
              <TableCell>{g.accountCode}</TableCell>
              {withTab && <TableCell>{g.tabId && formatTab(g.tabId, g.tabName)}</TableCell>}
              <TableCell align="right">{formatUsd(g.costUsd)}</TableCell>
              <TableCell align="right">
                {g.jobCount.toLocaleString()}
                <Typography component="span" variant="caption" color="text.secondary">
                  {` (成功 ${g.succeededCount} / 失敗 ${g.failedCount})`}
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formatPercent(successRate(g.succeededCount, g.jobCount))}
              </TableCell>
              <TableCell>{formatDateTime(g.lastRunAt)}</TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={colSpan} align="center">
                データがありません
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

interface Props {
  byAccount: LlmCostGroup[];
  byTab: LlmCostGroup[];
}

/** 内訳（アカウント別 / タブ別のコスト）のタブ切替 */
export function LlmCostBreakdownTabs({ byAccount, byTab }: Props) {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" mb={1}>
        内訳
      </Typography>
      <Tabs defaultValue="account">
        <TabsList>
          <TabsTrigger value="account">アカウント別</TabsTrigger>
          <TabsTrigger value="tab">タブ別</TabsTrigger>
        </TabsList>
        <TabsContent value="account">
          <GroupTable rows={byAccount} withTab={false} />
        </TabsContent>
        <TabsContent value="tab">
          <GroupTable rows={byTab} withTab />
        </TabsContent>
      </Tabs>
    </Paper>
  );
}
